<template>
    <div class="buttons">
        <button
            v-for="filter in filters"
            :key="filter.name"
            class="lb-button is-link"
        >
            <span class="icon is-medium" @click="$emit('removeFilter', filter)">
                <i class="mdi mdi-close"></i>
            </span>
            <span>{{ filter.name }}</span>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        filters: {
            type: Array,
            default() {
                return [];
            },
            required: true,
        },
    },
};
</script>

<style></style>
